import "antd/lib/form/style";
import _Form from "antd/lib/form";
import { connect } from 'dva';
import LayoutC from '../../components/Layouts/Index';
function mapDispatchToProps(_ref) {
  var layoutInfo = _ref.layoutInfo,
    indexPage = _ref.indexPage;
  return {
    layoutInfo: layoutInfo,
    indexPage: indexPage
  };
}
var LayoutR = _Form.create()(LayoutC);
export default connect(mapDispatchToProps)(LayoutR);